import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

import LabelForm from "../../Form/Label";

export const ModalBody = styled("section")(() => ({
  width: "100%",
}));

export const GridContainer = styled(Grid)(() => ({
  marginBottom: "1rem",
}));

export const TextEditorGridContainer = styled(Grid)(() => ({
  marginTop: 24,
}));

export const GridContainerTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "1rem",
  lineHeight: "1.5rem",
  color: "#475467",
  paddingRight: "0.3125rem",
  marginBottom: "24px",
}));

export const Label = styled(LabelForm, {
  shouldForwardProp(propName) {
    return propName !== "withOnClick";
  },
})(({ withOnClick }: { withOnClick?: boolean }) => ({
  lineHeight: "1.5rem",
  fontWeight: "bold",
  marginBottom: "0.65rem !important",
  cursor: withOnClick ? "pointer" : "default",
  color: `${colors.brandBlue500} !important`,
}));

export const Required = styled("span")(() => ({
  color: "#F97066",
  fontFamily: "Manrope",
  fontSize: 16,
}));

export const TextEditorContainer = styled(Grid)(() => ({
  position: "relative",
  marginTop: "10px !important",
}));

export const GridContainerSecondSeciton = styled(Grid)(() => ({
  marginTop: 8,
}));

const styles = makeStyles(() => ({
  modalBody: {
    width: "62vw !important",
  },
}));

export default styles;
